import styled from 'styled-components';

const Text = styled.label`
  font-size: 12px;
  color: ${props => props.theme.colors.textPrimary};
  margin-bottom: 0px;
  margin-top: 12px;
  ${props => props.danger && `color: ${props.theme.colors.danger};`};
`;

const PseudoInput = styled.input`
  border-radius: 8px;
  height: 35px;
  border: none;
  background: red;
  appearance: none;
  padding: 10px 5px;
  margin-top: 12px;
  font-size: 16px;
  border: 1px solid ${props => props.theme.colors.lightBlueGrey};
  color: ${props => props.theme.colors.charcoalGrey};
  background: #fff;
  ${props =>
    props.leftIcon &&
    `
    padding-left: 1.25rem;
    `};
  ${props =>
    props.type === 'file' &&
    `
    border: 0;
    padding: 0;
    background: blue;
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 38px;
  `};
  ${props =>
    props.danger &&
    `
    border: 1px solid ${props.theme.colors.danger};
    `};
  &:focus {
    outline: none;
    transition: 0.3s all;
    ${props =>
      props.primary &&
      `
      border: 1px solid ${props.theme.colors.primary};
    `};
    ${props =>
      props.textPrimary &&
      `
    border: 1px solid ${props.theme.colors.textPrimary};
    `};
    ${props =>
      props.success &&
      `
    border: 1px solid ${props.theme.colors.success};
    `};
    ${props =>
      props.info &&
      `
    border: 1px solid ${props.theme.colors.info};
    `};
    ${props =>
      props.danger &&
      `
    border: 1px solid ${props.theme.colors.danger};
    `};
  }
  &::placeholder {
    color: ${props => props.theme.colors.lightBlueGrey};
  }

  ${props =>
    props.disabled &&
    `
    background: ${props.theme.colors.lightGrey};
    cursor: not-allowed;
  `}
`;

const PseudoTextarea = styled.textarea`
  border: none;
  background: #fff;
  border: 1px solid ${props => props.theme.colors.lightBlueGrey};
  border-radius: 8px;
  padding: 10px;
  margin-top: 10px;
  resize: none;
  font-size: 16px;
  &:focus {
    outline: none;
    transition: 0.3s all;
    ${props =>
      props.primary &&
      `
      border: 1px solid ${props.theme.colors.primary};
    `};
    ${props =>
      props.textPrimary &&
      `
    border: 1px solid ${props.theme.colors.textPrimary};
    `};
    ${props =>
      props.success &&
      `
    border: 1px solid ${props.theme.colors.success};
    `};
    ${props =>
      props.info &&
      `
    border: 1px solid ${props.theme.colors.info};
    `};
    ${props =>
      props.danger &&
      `
    border: 1px solid ${props.theme.colors.danger};
    `};
  }
`;

const PseudoSelect = styled.select`
  border-radius: 8px;
  border: none;
  width: 100%;
  padding: 3px;
  height: 35px;
  margin: 12px 0;
  font-size: 16px;
  background: #fff;
  border: 1px solid ${props => props.theme.colors.lightBlueGrey};
  color: ${props => props.theme.colors.charcoalGrey};
  cursor: pointer;
  ${props =>
    props.type === 'file' &&
    `
    border: 0;
    padding: 0;
    background: blue;
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 38px;
  `};
  &:focus {
    outline: none;
    transition: 0.3s all;
    ${props =>
      props.primary &&
      `
      border: 1px solid ${props.theme.colors.primary};
    `};
    ${props =>
      props.textPrimary &&
      `
    border: 1px solid ${props.theme.colors.textPrimary};
    `};
    ${props =>
      props.success &&
      `
    border: 1px solid ${props.theme.colors.success};
    `};
    ${props =>
      props.info &&
      `
    border: 1px solid ${props.theme.colors.info};
    `};
    ${props =>
      props.danger &&
      `
    border: 1px solid ${props.theme.colors.danger};
    `};
  }
  &::placeholder {
    color: ${props => props.theme.colors.lightBlueGrey};
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: fit-content;

  ${props =>
    props.marginT &&
    `
    margin-top: ${props.marginT}px;
  `};
  ${props =>
    props.marginB &&
    `
    margin-bottom: ${props.marginB}px;
  `};
`;

export { Text, PseudoInput, PseudoSelect, PseudoTextarea, Container };
